export default __webpack_public_path__ + "static/media/project1_homePage.b66a1029.gif";